<app-training-record-delete #deleteRecordModal (deleted)="reloadTrainingRecords()"></app-training-record-delete>
<app-training-record-reminder #sendReminderForm></app-training-record-reminder>

<app-deprecated-modal-form
    #trainingRecordFormModal
    [form]="trainingRecordForm"
    (save)="trainingRecordForm.saveRecord()"
>
    <app-form-training-record
        #trainingRecordForm
        [record]="currentTrainingProgramRecord"
        (saveRecordEvent)="reloadTrainingRecords()"
    ></app-form-training-record>
</app-deprecated-modal-form>

<app-deprecated-modal-form
    #trainingOnceOffModal
    (save)="trainingOnceOffForm.saveRecord()"
    (close)="trainingOnceOffForm.close()"
    [hideOnSave]="false"
    headerText="training.trainingProgramDetails"
>
    <app-training-once-off-form
        #trainingOnceOffForm
        (closeDialogue)="onOnceOffModalClose()"
        (saved)="onOnceOffModalSave()"
    ></app-training-once-off-form>
</app-deprecated-modal-form>

<!-- Body -->
<div class="ui basic segment">
    <app-employee-header [employee]="employee"></app-employee-header>

    <div class="ui layout">
        <div class="sidebar">
            <app-profile-card [model]="employee"></app-profile-card>
        </div>

        <div class="content" [class.loading]="isLoading">
            <!--Training program records-->
            <div class="content">
                <div class="ui table section">
                    <div class="ui segment">
                        <app-table
                            [table]="upcoming"
                            [showSearch]="false"
                            [useStickyHeader]="false"
                            [title]="'training.upcomingTraining' | translate"
                            [embedded]="true"
                            [isSmall]="true"
                            (menuItemSelected)="menuAction($event)"
                        >
                            <app-empty-state
                                [label]="'training.noTrainingProgramsFound' | translate"
                                src="/assets/illustrations/chair.png"
                            ></app-empty-state>
                        </app-table>
                    </div>
                </div>
                <div class="ui table section completed-section">
                    <div class="ui segment">
                        <app-table
                            [table]="completed"
                            [showSearch]="false"
                            [useStickyHeader]="false"
                            [title]="'training.completedTraining' | translate"
                            [embedded]="true"
                            [isSmall]="true"
                            (menuItemSelected)="menuAction($event)"
                        >
                            <app-empty-state
                                [label]="'training.noTrainingProgramsFound' | translate"
                                src="/assets/illustrations/chair.png"
                            ></app-empty-state>
                        </app-table>
                        <div *permission="permission">
                            <button mat-button color="primary" (click)="onCreateNew()">
                                + {{ 'training.completedTraining' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
